import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Spinner from './components/lazyLoadFallback/Spinner'
import { CompanyProvider } from './context/CompanyContext';
import { UserProvider } from './context/UserContext';
import { WEBVIEW_GUARD_ENABLED } from './configs/appConfig';
import { detectBlockedClient } from './configs/environmentGuard';

// Check for saved theme preference or use system preference
const savedTheme = localStorage.getItem('theme');
if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

const LazyApp = lazy(() => import('./App'))

const root = ReactDOM.createRoot(document.getElementById('root')!);

// WebView / masaüstü wrapper + bot/otomasyon engelleme: env'de açıksa ve
// engellenecek bir istemci tespit edilirse uygulamayı hiç başlatma.
const guard = WEBVIEW_GUARD_ENABLED ? detectBlockedClient() : { blocked: false, reason: null };

if (guard.blocked) {
  // Bilinçli olarak HİÇBİR uyarı/mesaj gösterme. Tespit edilen tarafın bunu bir
  // engelleme olarak algılamaması, sıradan bir yükleme hatası / bozuk sayfa
  // sanması için bembeyaz boş bir sayfa bırak. (Konsola da iz bırakma.)
  document.documentElement.classList.remove('dark');
  document.documentElement.style.backgroundColor = '#ffffff';
  document.body.style.backgroundColor = '#ffffff';
  root.render(null);
} else {
  root.render(
    <React.StrictMode>
      <Suspense fallback={<Spinner />}>
        <UserProvider>
          <CompanyProvider>
            <LazyApp />
          </CompanyProvider>
        </UserProvider>
      </Suspense>
    </React.StrictMode>
  );
}
